export interface Character {
  id: string;
  name: string;
  kana: string;
  role: string;
  tagline: string;
  desc: string;
  tags: string[];
  image: string;
  accent: 'primary' | 'accent' | 'secondary';
}

export const characters: Character[] = [
  {
    id: 'meisa',
    name: '黑田美咲',
    kana: 'くろだ みさき',
    role: '女主角 · 辣妹',
    tagline: '张扬外表下藏着一颗细腻的心',
    desc: '全校最惹眼的辣妹，妆容大胆、性格爽朗，朋友众多。可谁能想到，她其实是个重度漫画迷，尤其痴迷少年热血漫。因为家中的突发状况，她暂时住进悠斗家，从此开启一段又吵又甜的"寄居"日常。',
    tags: ['辣妹', '漫画迷', '反差萌', '坦率'],
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20character%20portrait%20of%20a%20friendly%20gyaru%20high%20school%20girl%20with%20tanned%20skin%2C%20light%20blonde%20hair%20in%20loose%20curls%2C%20confident%20warm%20smile%2C%20wearing%20a%20trendy%20casual%20coral%20and%20white%20outfit%2C%20soft%20peach%20gradient%20studio%20background%2C%20clean%20colorful%20anime%20artwork%2C%20high%20detail&width=800&height=1000&seq=char-meisa&orientation=portrait',
    accent: 'primary',
  },
  {
    id: 'yuto',
    name: '佐藤悠斗',
    kana: 'さとう ゆうと',
    role: '男主角 · 普通高中生',
    tagline: '安静又温柔的漫画收藏家',
    desc: '性格内向、成绩中等的普通高中生，唯一的爱好是收藏和阅读漫画。家里堆满书架的私人收藏，原本只属于自己的小天地，却因为美咲的到来变得热闹起来。嘴上嫌麻烦，行动上却总是默默照顾着美咲。',
    tags: ['漫画宅', '温柔', '慢热', '反差'],
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20character%20portrait%20of%20a%20shy%20quiet%20teenage%20high%20school%20boy%20with%20short%20dark%20hair%20and%20round%20glasses%2C%20gentle%20awkward%20expression%2C%20wearing%20a%20simple%20beige%20sweater%2C%20soft%20warm%20coral%20gradient%20studio%20background%2C%20clean%20colorful%20anime%20artwork%2C%20high%20detail&width=800&height=1000&seq=char-yuto&orientation=portrait',
    accent: 'secondary',
  },
  {
    id: 'china',
    name: '藤井千夏',
    kana: 'ふじい ちなつ',
    role: '美咲的闺蜜 · 同班辣妹',
    tagline: '全场的开心果与气氛担当',
    desc: '和美咲形影不离的辣妹好友，性格超级外放，总是第一个起哄、第一个带头八卦。看似没心没肺，其实非常讲义气，是两人关系里最早的"神助攻"和最可靠的传话筒。',
    tags: ['辣妹', '神助攻', '活泼', '讲义气'],
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20character%20portrait%20of%20a%20playful%20gyaru%20high%20school%20girl%20with%20tanned%20skin%20and%20long%20straight%20dark%20hair%20with%20pink%20highlights%2C%20mischievous%20big%20smile%2C%20wearing%20a%20cute%20off%20shoulder%20top%2C%20soft%20peach%20gradient%20studio%20background%2C%20clean%20colorful%20anime%20artwork%2C%20high%20detail&width=800&height=1000&seq=char-china&orientation=portrait',
    accent: 'accent',
  },
  {
    id: 'mikoto',
    name: '佐藤美琴',
    kana: 'さとう みこと',
    role: '悠斗的妹妹 · 吐槽担当',
    tagline: '全家的冷静观察员',
    desc: '悠斗的妹妹，比哥哥成熟许多的高中生。对哥哥"藏娇"这件事表现出超乎年龄的淡定，常常一边吐槽一边暗中帮忙。是她最早看穿了美咲的真心，也是推动剧情的关键人物。',
    tags: ['妹妹', '毒舌', '人小鬼大', '观察力强'],
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20character%20portrait%20of%20a%20calm%20mature%20teenage%20high%20school%20girl%20with%20neat%20dark%20hair%20tied%20in%20a%20side%20ponytail%2C%20slightly%20smirking%20expression%2C%20wearing%20a%20simple%20casual%20shirt%2C%20soft%20warm%20peach%20gradient%20studio%20background%2C%20clean%20colorful%20anime%20artwork%2C%20high%20detail&width=800&height=1000&seq=char-mikoto&orientation=portrait',
    accent: 'secondary',
  },
  {
    id: 'kazuma',
    name: '高桥和真',
    kana: 'たかはし かずま',
    role: '悠斗的好友 · 情报通',
    tagline: '永远冲在八卦最前线',
    desc: '悠斗从小到大的死党，班级里的活跃分子，堪称"班级广播站"。对美咲住进悠斗家这件事兴奋得不行，几乎承包了全篇一半的搞笑戏份，也是两人关系最早的见证者。',
    tags: ['死党', '八卦', '搞笑', '热心'],
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20character%20portrait%20of%20a%20lively%20cheerful%20teenage%20high%20school%20boy%20with%20spiky%20short%20hair%20and%20bright%20grin%2C%20energetic%20posture%2C%20wearing%20a%20casual%20jacket%2C%20soft%20warm%20coral%20gradient%20studio%20background%2C%20clean%20colorful%20anime%20artwork%2C%20high%20detail&width=800&height=1000&seq=char-kazuma&orientation=portrait',
    accent: 'accent',
  },
];